import { AnalyticsStore } from '../AnalyticsStore';
import { MraidStore } from '../MraidStore';

interface UserExpandHandlerProps {
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
}
export class UserExpandHandler {
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
  creativeExpandFirstSent: boolean;

  constructor({ analyticsStore, mraidStore }: UserExpandHandlerProps) {
    this.analyticsStore = analyticsStore;
    this.mraidStore = mraidStore;
    this.creativeExpandFirstSent = false;
  }

  handle(e: React.MouseEvent | React.TouchEvent) {
    e.stopPropagation();
    if (this.mraidStore.isMraidExpanded) {
      this.mraidStore.collapse();
      this.analyticsStore.sendCreativeTrack('collapse');
    } else {
      this.mraidStore.expand();

      if (!this.creativeExpandFirstSent) {
        this.analyticsStore.sendCreativeTrack('expand_first');
        this.creativeExpandFirstSent = true;
      }

      this.analyticsStore.sendCreativeTrack('expand');
    }
  }
}
